import React, { useEffect, useState } from "react";
import {
  ButtonGroup,
  UncontrolledDropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import useAxios from "../../../Utils/useAxios";
import { Link } from "react-router-dom";
import ModalRIB from "./ModalRIB";
import DataTable from "react-data-table-component";
import { formatRP } from "../../../Utils/externalFunctions";
import DataTableTitle from "../../DataTableComponents/DataTableTitle";
import FilterComponent from "../../FilterComponents/FilterComponent";
import { filterSearch } from "../../../Utils/FilterItems";
import { useThemeContext } from "../../../Context/ThemeContext";
import { getDarkDropdown } from "../../../Utils/otherFunctions";
import FeatureContainer from "../../../Layout/Containers/FeatureContainer";
import { FEATURE_FUNCTION_SELECTION } from "../../../Constant/FeatureSelection";
import { Info, PlusCircle } from "react-feather";

const AnggaranBulananContain = () => {
  const axiosInstance = useAxios();

  const [updatedAnggaranBUK, setUpdatedAnggaranBUK] = useState([]);
  const [selectedAnggaran, setSelectedAnggaran] = useState(0);
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  const [filterText, setFilterText] = useState("");
  const [resetPaginationToggle, setResetPaginationToggle] = useState(false);

  const [pending, setPending] = useState(true);

  const { themeContext } = useThemeContext();

  let isMounted = true;
  useEffect(() => {
    const fetchData = () => {
      getAnggaranBulanan();
    };

    if (isMounted) fetchData();

    return () => {
      isMounted = false;
    };
  }, []);

  const getAnggaranBulanan = async () => {
    await axiosInstance.get("opt/anggaranbuk/").then((res) => {
      setUpdatedAnggaranBUK(res.data);
      setPending(false);
    });
  };

  const handleClear = () => {
    if (filterText) {
      setResetPaginationToggle(!resetPaginationToggle);
      setFilterText("");
    }
  };

  const filterAnggaran = (items) => {
    const searchCategories = ["id_unit_kerja"];
    const filteredItems = items.filter(
      filterSearch(searchCategories, filterText)
    );
    return filteredItems;
  };

  const DaftarAnggaranColumns = [
    {
      name: <DataTableTitle text={"DPSJ"} />,
      selector: (row) => row.id_unit_kerja,
      sortable: true,
      wrap: true,
    },
    {
      name: <DataTableTitle text={"Anggaran (Rp)"} />,
      selector: (row) => parseInt(row.total_anggaran),
      sortable: true,
      format: (row) => formatRP(row.total_anggaran),
    },
    {
      name: <DataTableTitle text={"Realisasi (Rp)"} />,
      selector: (row) => parseInt(row.total_terpakai),
      sortable: true,
      format: (row) => formatRP(row.total_terpakai),
    },
    {
      name: <DataTableTitle text={"Sisa (Rp)"} />,
      selector: (row) => parseInt(row.total_sisa),
      sortable: true,
      format: (row) => formatRP(row.total_sisa),
    },
    {
      name: <DataTableTitle text={"Operasi"} />,
      cell: (row) => (
        <ButtonGroup>
          <UncontrolledDropdown direction="up">
            <DropdownToggle caret></DropdownToggle>
            <DropdownMenu>
              <DropdownItem
                className={`d-flex align-items-center gap-2 ${getDarkDropdown(
                  themeContext
                )}`}
                onClick={() => {
                  toggle();
                  setSelectedAnggaran(row);
                }}
              >
                <Info size={12} />
                Rincian Anggaran
              </DropdownItem>
              <DropdownItem divider />

              {FEATURE_FUNCTION_SELECTION.Transaksi.Create && (
                <Link to={`${process.env.PUBLIC_URL}/transaksi/buattransaksi`}>
                  <DropdownItem
                    className={`text-success d-flex align-items-center gap-2 ${getDarkDropdown(
                      themeContext
                    )}`}
                  >
                    <PlusCircle size={12} />
                    Buat Transaksi
                  </DropdownItem>
                </Link>
              )}
            </DropdownMenu>
          </UncontrolledDropdown>
        </ButtonGroup>
      ),
    },
  ];

  return (
    <FeatureContainer title={"Anggaran"}>
      <DataTable
        columns={DaftarAnggaranColumns}
        data={filterAnggaran(updatedAnggaranBUK)}
        pagination
        selectableRowsHighlight
        highlightOnHover
        subHeader
        subHeaderComponent={
          <FilterComponent
            onFilter={(e) => {
              setFilterText(e.target.value);
            }}
            onClear={() => handleClear()}
            filterText={filterText}
          />
        }
        subHeaderAlign="right"
        persistTableHead
        progressPending={pending}
        theme={themeContext}
      />
      <ModalRIB
        modal={modal}
        toggle={toggle}
        selectedAnggaran={selectedAnggaran}
      />
    </FeatureContainer>
  );
};
export default AnggaranBulananContain;
